import React from 'react';
import { LogOut } from 'lucide-react';
import { useLogout } from '../../../../core/hooks/useLogout';

const SidebarFooter: React.FC = () => {
  const { logout } = useLogout();
  return (
    <div className="p-4 border-t border-gray-200/50">
      <button
        onClick={logout}
        className="flex items-center gap-3 w-full px-4 py-2.5 rounded-lg text-sm font-bold text-red-600 hover:bg-red-50 transition-all group"
      >
        <LogOut className="w-5 h-5 group-hover:rotate-12 transition-transform" />
        <span>Déconnexion</span>
      </button>
    </div>
  );
};

export default SidebarFooter;